import { TefComs4p } from '@mfe/components/TefComs4p';
import { Subscription } from '@mfec/types/model';
import { formatMsisdn } from '@mfec/utils/MobilePhoneNumber';
import { html } from 'lit';

//
// renders a single subscription block in EDIT mode
//
// {subscription msisdn}
//   {app consent BLOCK}
//
export const singleSubscriptionEdit = function render(this: TefComs4p, subscription : Subscription)
  : ReturnType<typeof html> {
  return html`
    <div class="container container--size-full container--prio-bg-3">
      <h6 class="u-sy--tight" style="padding: 10px 0">${formatMsisdn(subscription.msisdn)}</h6>
    </div>
    <div class="container u-sy--tight">
      ${subscription.apps.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <div class="row">
        <a class="button button-tag button-tag--size-small" @click="${() => { this.revokeAllAppConsentsForSubscription(subscription); }}">
          Alle deaktivieren 
        </a>
      </div>
    </div>
  `;
};
